import { apiClient } from "../../../lib";

class ResourceReqService {

    async getResourceReqs(params: Record<string, any>) {
       const searchParams = new URLSearchParams();
             Object.entries(params || {}).forEach(([key, value]) => {
                 if (Array.isArray(value)) {
                     value.forEach(v => {
                         if (v) searchParams.append(key, String(v));
                     });
                 } else if (value) {
                     searchParams.append(key, String(value));
                 }
             });
        const queryString = searchParams.toString()
      const response = await apiClient.get(`/resource-request?${queryString}`);
        return response.data;
    };

    async getResourceReqById({ projectId, requestId }: { projectId: string | undefined, requestId: string | null }) {
        const response = await apiClient.get(`/resource-request/${requestId}`);
        return response.data;
    };

    async createResourceReq(data: any) {
        const response = await apiClient.post("/resource-request", data);
        return response.data;
    };

    async updateResourceReq(id: string, data: any) {
        const response = await apiClient.put(`/resource-request/${id}`, data);
        return response.data;
    };

    async deleteResourceReq(id: string) {
        const response = await apiClient.delete(`/resource-request/${id}`);
        return response.data;
    };

    async getActivitys(projectId: string | undefined, phaseId: string) {
        const response = await apiClient.get(`/projects/${projectId}/activities`, { params: { parent_id: phaseId } });
        return response.data;
    };

};

export const resourceReqService = new ResourceReqService();
export default resourceReqService;